(function () {
  angular
    .module("akitabox.ui.dialogs.inspectionProgram.cancel")
    .factory("CancelInspectionProgramDialog", CancelInspectionProgramDialog);

  /* @ngInject */
  function CancelInspectionProgramDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/inspection-program/cancel/cancel-inspection-program.dialog.html",
      controller: "CancelInspectionProgramDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.inspectionProgramIDs` and `options.locals.buildingId` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the canceled inspectionPrograms
     */
    function show(options) {
      // Verify we have inspectionProgramIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.inspectionPrograms ||
        !options.locals.inspectionPrograms.length > 0
      ) {
        $log.error(
          "CancelInspectionProgramDialog: you must pass in InspectionProgramIDs via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
